<template>
  <el-container id="el-header">
    <div id="el-brand">
      <div style="float: left">
        <img
          src="@/assets/daxiang.png"
          style="width: 32x; height: 32px; margin: 8px 8px 8px 16px"
        />
      </div>
      <div class="brand-text">朋游机票</div>
    </div>
    <div id="el-fold" @click="collapse">
      <el-icon>
        <component :is="Fold" />
      </el-icon>
    </div>
    <div id="user">
      <el-link
        :underline="false"
        icon="el-icon-user-solid"
        style="margin-right: 4px"
        ><span
          @click="toLogin"
          :style="{ display: isLoginDisplay ? '' : 'none' }"
          >登录</span
        ></el-link
      >
      <el-dropdown :style="{ display: !isLoginDisplay ? '' : 'none' }">
        <span class="el-dropdown-link">
          {{ username }}
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="loginOut">退出</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-container>
</template>

<script>
import { getCurrentInstance, ref, watch } from "vue";
import { Fold } from "@element-plus/icons-vue";
export default {
  // 接收父组件的事件
  emits: ["collapse-sidebar"],
  props: ["refreshUser"],
  // 解构 context
  setup(props, { emit }) {
    const isCollapse = ref(false);
    const { proxy } = getCurrentInstance();
    let username = ref("未登录");
    let isLoginDisplay = ref("false");
    function collapse() {
      // 改变折叠状态
      isCollapse.value = !isCollapse.value;

      // 调用父组件的事件传递参数给父组件
      emit("collapse-sidebar", isCollapse.value);
    }

    // 重新刷新用户
    watch(
      () => props.refreshUser,
      () => {
        getUser();
        console.log("refreshUser 已改变");
      }
    );

    getUser();

    // 获取用户名
    function getUser() {
      proxy.$http.get("/authentication/username").then((response) => {
        console.log(response);
        if (response === "FORBIDDEN") {
          username.value = "登录";
          isLoginDisplay.value = true;
          return;
        }
        isLoginDisplay.value = false;
        username.value = response;
        console.log(username);
      });
    }

    // loginOut
    function loginOut() {
      proxy.$cookie.remove("accessToken");
      proxy.$router.push("/login");
    }

    function toLogin() {
      proxy.$router.push("/login");
    }
    console.log("router");
    console.log(proxy.$router);
    console.log(proxy.$router.options.routes[0].children.length);

    return {
      isCollapse,
      collapse,
      username,
      loginOut,
      toLogin,
      isLoginDisplay,
      Fold,
    };
  },
};
</script>
<style>
#el-header {
  height: 100%;
  background-color: #fff;
  color: #333;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
}

#el-brand {
  width: 208px;
  padding: 0px 0px;
}
.brand-text {
  font-family: STHeiti;
  font-size: 28px;
  letter-spacing: 2px;
  float: left;
  font-weight: 600;
  margin-top: 4px;
  color: #007aff;
}

#el-fold {
  line-height: 100%;
  font-size: 26px;
  align-self: center;
}
#user {
  position: absolute;
  text-align: right;
  padding-right: 24px;
  left: 326px;
  width: calc(100% - 370px);
  align-self: center;
}
</style>
